import { render } from "./ConnectAndPolygonModal.vue?vue&type=template&id=9b83fd4e&scoped=true"
import script from "./ConnectAndPolygonModal.vue?vue&type=script&lang=js"
export * from "./ConnectAndPolygonModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/connectionAndPolygonModal.scss?vue&type=style&index=0&id=9b83fd4e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b83fd4e"]])

export default __exports__